var map = {
	"./Temp baker-steel-electrum.csv": 527,
	"./baker-steel-electrum.csv": 528,
	"./baker-steel-gold-i.csv": 529,
	"./baker-steel-gold.csv": 530,
	"./india-avenue-i.csv": 531,
	"./india-avenue.csv": 532,
	"./msc-sanlam-medallion.csv": 533,
	"./old baker-steel-gold-i.csv": 534,
	"./old baker-steel-gold.csv": 535,
	"./old india-avenue-i.csv": 536,
	"./old india-avenue.csv": 537,
	"./old reitway-global-property-i.csv": 538,
	"./old reitway-global-property.csv": 539,
	"./old sanlam-real-assets.csv": 540,
	"./old spw-global-high-quality-i.csv": 541,
	"./old spw-global-high-quality.csv": 542,
	"./old1 spw-global-high-quality.csv": 543,
	"./reitway-global-property-i.csv": 544,
	"./reitway-global-property.csv": 545,
	"./sanlam-real-assets.csv": 546,
	"./spw-global-high-quality-i.csv": 547,
	"./spw-global-high-quality.csv": 548,
	"./spw-global-income.csv": 549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 526;